import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewPlanEstimateDetailsModal = ({ isOpen, onClose, plan }) => {
    const { t } = useTranslation();

    if (!isOpen || !plan) return null;

    return (
       <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.planEstimateDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {/* Primary Plan Information */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 mt-2 px-4">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('forms.planEstimate.workName')} :
                            </label>
                            <span className="text-sm font-bold text-gray-800">{plan.nameOfWork}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('forms.planEstimate.location')} :
                            </label>
                            <span className="text-sm text-gray-700">{plan.districtName}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('forms.planEstimate.workType')} :
                            </label>
                            <span className="text-sm text-gray-700">{plan.workTypeName}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('forms.planEstimate.estimateCost')} :
                            </label>
                            <span className="text-sm font-bold">{formatCurrency(plan.estimateCost || '')}</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label whitespace-nowrap" style={{ marginBottom: 0 }}>
                                {t('forms.planEstimate.date')} :
                            </label>
                            <span className="text-sm text-gray-700">{plan.date || "N/A"}</span>
                        </div>
                    </div>

                    {/* Attachments Table */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" style={{ width: '95%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold">{t('tables.attachmentDesc')}</th>
                                    <th className="p-2 text-center font-bold w-48">{t('tables.file')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plan.attachmentData && plan.attachmentData.length > 0 ? (
                                    plan.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.description}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || t('common.view')}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('forms.common.noFile')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('forms.common.noAttachment')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className="staff-form-footer p-4 flex justify-center border-t">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewPlanEstimateDetailsModal;